import vars from '../helpers';
import {initSimplebar, destroySimplebar} from '../components/simple-bar';
import gallery from '../components/gallery';
import swiperGalleryPopup from '../components/swiper-gallery-popup';
import swiperGallery from '../components/swiper-gallery';
import sliderReview from '../components/slider-review';

function readMore(container) {
	let $wrapper = container.querySelector('.js-review-content');
	let $text = $wrapper.querySelectorAll('p');

	const showChar = 250;
	const ellipsesText = " ...";
	const readMore = "читать полностью";
	let commonLength = 0;

	$text.forEach(element => {
		commonLength += $(element).html().length;
	});

	let content = $($text).html();

	if (commonLength > (showChar * 2)) {
		let show_content = content.substr(0, showChar);
		let hide_content = content.substr(showChar, content.length - showChar);
		let html =
			show_content +
			'<span class="moreEllipses">' +
			ellipsesText +
			'</span><span class="hidden-content"><span>' +
			hide_content +
			'</span>&nbsp;<a class="moreText__btn js-moreText">' +
			readMore +
			"</a></span>";
		$($text).html(html);
	} else {
		$($wrapper).addClass('is-visible');
	}

	const $btnShowHide = container.querySelector('.js-moreText');
	const $sliderReviews = container.querySelector('.js-slider-review');

	$($btnShowHide).click(function() {
		if (!$($wrapper).hasClass('is-show')) {
			$($wrapper).addClass('is-show');

			if($sliderReviews) {
				sliderReview.update();
			}
		}
	});
}

function init(container, isFirst) {
	if( $(window).width() > 768 ) {
		initSimplebar(container);
		swiperGalleryPopup.init(container);
	}

	swiperGallery.init(container);
	gallery.init(container);
	sliderReview.init(container);
	readMore(container);

	// openGalleryPopup();
}

function destroy() {
	vars.$html.removeClass('is-lock-scroll is-menu-opened');
	destroySimplebar();
	gallery.destroy();
	swiperGallery.destroy();
	if (!vars.isMobile()) {
		swiperGalleryPopup.destroy();
	}
	sliderReview.destroy();
}

export default {
	init,
	destroy,
};
